import { FileIdList, Transaction } from '@kalos/kalos-rpc';
import { useMutation } from '@tanstack/react-query';

import { S3ClientService, TransactionClientService } from '../../tools/helpers';

export const useDownloadZipMutation = (
  opts?: Parameters<
    typeof useMutation<void, unknown, Parameters<typeof S3ClientService.DownloadZip>['0'], unknown>
  >['0'],
) => {
  return useMutation({
    mutationFn: async (req: FileIdList) => {
      await S3ClientService.DownloadZip(req);
    },
    ...opts,
  });
};

export const useDownloadTransactionFilesZipMutation = (
  opts?: Parameters<
    typeof useMutation<number, unknown, { jobId: number; filename?: string }, unknown>
  >['0'],
) => {
  return useMutation({
    mutationFn: async ({ jobId, filename }: { jobId: number; filename?: string }) => {
      const fileIdsRes = await TransactionClientService.GetTransactionFileIdsByJob(
        Transaction.create({ jobId }),
      );
      const fileIds = fileIdsRes?.values ?? [];
      if (fileIds.length === 0) {
        return 0;
      }
      await S3ClientService.DownloadZip(
        FileIdList.create({ fileIds, sizeType: 'original' }),
        filename,
      );
      return fileIds.length;
    },
    ...opts,
  });
};
